import React from 'react';

import Navbar from 'react-bootstrap/Navbar';
import imed from '../../../images/logo.png';

import './index.scss';

function MenuNavbar() {
  return (
    <Navbar.Brand className="logoNavbar">
      <img
        alt=""
        src={imed}
        className="d-inline-block align-top"
      />
    </Navbar.Brand>
  );
}

export default MenuNavbar;
